module.exports = __webpack_public_path__ + "img/s3_img@2x.e9745863.png";